import GetMyInscription from '../components/GetMyInscription';

export default function MyInscription() {
  return (
    <div>
      <GetMyInscription />
    </div>
  );
}
